<button
  [attr.aria-label]="label() || null"
  [style.border-color]="color()"
  [style]="{ 'background-color': foreground() ? foreground() : undefined }"
  class="bordered-button p-2 m-b-1 surface"
  mat-ripple
  type="button"
  tabindex="0"
  data-testid="bordered-icon-button-container"
>
  <mat-icon
    [style.color]="color()"
    aria-hidden="true"
    class="no-pad"
    data-testid="bordered-icon-button-icon"
    >{{ icon() }}</mat-icon
  >
</button>
